"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDateInPast = function isDateInPast(message) {
  return function (_ref) {
    var field = _ref.field;

    // This is not an 'isRequired' validator
    if (!field.value) {
      return true;
    }

    var enteredDate = (0, _moment.default)(field.value, 'DD/MM/YYYY');
    var now = (0, _moment.default)();
    var isValid = enteredDate.isBefore(now);
    return [isValid, message || 'Please enter a date in the past'];
  };
};

var _default = isDateInPast;
exports.default = _default;
//# sourceMappingURL=isDateInPast.js.map